import React from 'react'
import * as Bootstrap from 'react-bootstrap'

const GrupoBotonesFlujo = ({onCancelar, onGuardar, onGuardarYContinuar, personaTalentos}) => {
    return (
        <Bootstrap.Form.Group
            className="display-flex space-between"
            as={Bootstrap.Col}
            md="12"
        >
            {personaTalentos && (
                <Bootstrap.Button
                    size="medium"
                    variant="light"
                    onClick={onCancelar}
                >
                    <strong> Cancelar edición </strong>
                </Bootstrap.Button>
            )}
            <div>
                <Bootstrap.Button
                    size="medium"
                    type="button"
                    onClick={onGuardar}
                >
                    <strong> Guardar </strong>
                </Bootstrap.Button>
                <Bootstrap.Button
                    className={"margin-left-5"}
                    size="medium"
                    type="button"
                    onClick={onGuardarYContinuar}
                >
                    <strong> Guardar y continuar </strong>
                </Bootstrap.Button>
            </div>
        </Bootstrap.Form.Group>
    )
}

export default GrupoBotonesFlujo